
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Link, Image } from '@ta-interaktiv/contentbricks'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>
Verschiedene Forscher gehen davon aus, dass die Dunkelziffer hoch ist, es neben bestätigten Fällen also auch noch viele gibt, von denen man nichts weiss. Das würde die Sterblichkeitsrate senken. 
      <Link href='https://twitter.com/AdamJKucharski/status/1235700923978129408?s=20' mdxType="Link">Adam Kucharski</Link>, Mathematiker und Epidemiologe an der London School of Hygiene & Tropical Medicine, hat berechnet, 
dass die Rate bei Fällen mit Symptomen (Case Fatality Rate) 1,1 Prozent beträgt. Wenn man auch die Fälle ohne Symptome mit einbezieht (Infection Fatality Rate), sind es 0,5 Prozent. Der Schweizer
 Epidemologe <Link href='https://twitter.com/C_Althaus/status/1236287416278884357?s=20' mdxType="Link">Christian Althaus</Link> kommt auf einen leicht höheren Wert von 1,6 Prozent.
    </p>
    <p>
Klar bleibt auch mit diesen Zahlen: Die neue Krankheit mit dem Namen Covid-19 ist deutlich schwerer als eine saisonale Grippe und fünf- bis fünfzehnmal so gefährlich, was die Sterblichkeit betrifft. 
Besonders gefährdet sind Menschen mit Vorerkrankungen wie Bluthochdruck, Diabetes und Herz-Gefäss-Erkrankungen sowie grundsätzlich ältere Personen. Ab 65 Jahren steigt das Risiko für Komplikationen deutlich.
    </p>
    <p><a href='https://interaktiv.tagesanzeiger.ch/2020/coronavirus-analyse-sterblichkeit/?nosome'>
  <img src='https://interaktiv.tagesanzeiger.ch/2020/coronavirus-analyse-sterblichkeit/inline_teaser.jpg' width='100%' />
      </a>
    </p>
    <p>
Der R0-Wert sagt nicht zwingend etwas über die Gefährlichkeit eines Virus aus. Die Masern zum Beispiel haben eine höhere Ansteckungsrate als das neue Coronavirus, aber in Industrieländern eine viel 
tiefere Sterblichkeit (weniger als 0,03 Prozent). In Entwicklungsländern kann diese um ein Vielfaches höher sein. Ebola ist deutlich weniger ansteckend als die Masern, das Fieber verläuft aber je 
nach Virusart und Region in 25 bis 90 Prozent aller Fälle tödlich.
    </p>
    <p>
Auch von der Spanischen Grippe ging im Vergleich zu den Masern eine relativ geringe Ansteckungsgefahr aus. Ihr R0-Wert war etwa gleich wie beim aktuellen Coronavirus. Trotzdem steckte sie in den Jahren 
1918 bis 1920 bis zu einer halben Milliarde Menschen an, ein Drittel der damaligen Weltbevölkerung. Forscher vermuten, dass das Virus zuerst in Amerika auftrat, durch US-Soldaten im Ersten Weltkrieg nach 
Europa gelangte und sich von dort über den gesamten Globus ausbreitete. Durch winzige Tröpfchen beim Husten oder Niesen steckten sich die Menschen reihenweise an.
    </p>
    <p>Viele Menschen litten damals bereits an anderen Krankheiten wie Tuberkulose. Zudem handelte es sich um einen aussergewöhnlich aggressiven Virustyp, der in mehreren Wellen innerhalb weniger Monate kam. 
  Antibiotika, moderne Impfstoffe und Therapien gab es noch nicht. Die Spanische Grippe forderte gemäss unterschiedlichen Berechnungen weltweit 20, 50 oder sogar 100 Millionen Tote. Je nach Schätzung 
  starben also bis zu 20 Prozent der Infizierten.</p>
    <Image file={[require('images/grafx_chart-detail-mobile.jpg'), require('images/grafx_chart-detail.jpg')]} source='Quelle: WHO, verschiedene Studien, National Health Commission of China' mdxType="Image" />
    <p>
Eine Besonderheit der Spanischen Grippe war, dass ihr vor allem 20- bis 40-jährige Menschen erlagen, während Influenzaviren sonst besonders Kinder und ältere Menschen gefährden. Pro Jahr gibt es weltweit 
bis zu 900 Millionen Influenzafälle, dabei sterben 200'000 bis 650'000 Personen. In der Schweiz verläuft die saisonale Grippe jedes Jahr für 300 bis 2500 Personen tödlich.
    </p><p>
Das neue Coronavirus ist Stand jetzt weniger gefährlich für Kinder, dafür umso mehr für ältere Personen und solche mit Vorerkrankungen. Die Sterblichkeitsrate ist wie beschrieben fünf- bis fünfzehnmal so
 hoch wie bei der saisonalen Grippe. Sollte sich Sars-CoV-2 auch nur annähernd so stark auf der Welt ausbreiten wie Influenza, wäre das fatal.
    </p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;